import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";
import { administrativeError } from "../administrativeError";

export async function updateRolePermissions(roleName, permissions) {
    try {
        const response = await axios.put(
            `${FIRMFLOWURL}api/admin/roles/${encodeURIComponent(roleName)}/permissions`,
            { permissionKeys: permissions },
            { headers: { Authorization: Cookies.get("Bearer") }, suppressForbiddenToast: true, timeout: 30000 },
        );
        return { ...response, success: true };
    } catch (error) {
        // No payload fallback or automatic mutation retries.
        return administrativeError(error, "Failed to update permissions. Review and try again.");
    }
}
